import { Metadata } from 'next'

/* eslint-disable max-len */
import shipplayAboutLayoutMetadata from '@/app/about/shipplay.layout.metadata'
import shipplayAboutPageContent from '@/app/about/shipplay.page.content'
import shipskisAboutLayoutMetadata from '@/app/about/shipskis.layout.metadata'
import shipskisAboutPageContent from '@/app/about/shipskis.page.content'
import shipsticksAboutLayoutMetadata from '@/app/about/shipsticks.layout.metadata'
import type { AboutPageContent } from '@/app/about/shipsticks.page.content'
import shipsticksAboutPageContent from '@/app/about/shipsticks.page.content'
import shipplayAffiliateLayoutMetadata from '@/app/affiliate/shipplay.layout.metadata'
import shipplayAffiliatePageContent from '@/app/affiliate/shipplay.page.content'
import shipskisAffiliateLayoutMetadata from '@/app/affiliate/shipskis.layout.metadata'
import shipskisAffiliatePageContent from '@/app/affiliate/shipskis.page.content'
import shipsticksAffiliateLayoutMetadata from '@/app/affiliate/shipsticks.layout.metadata'
import type { AffiliatePageContent } from '@/app/affiliate/shipsticks.page.content'
import shipsticksAffiliatePageContent from '@/app/affiliate/shipsticks.page.content'
import shipplayHomeLayoutMetadata from '@/app/booking-widget/shipplay.layout.metadata'
import shipplayHomePageContent from '@/app/booking-widget/shipplay.page.content'
import shipskisHomeLayoutMetadata from '@/app/booking-widget/shipskis.layout.metadata'
import shipskisHomePageContent from '@/app/booking-widget/shipskis.page.content'
import shipsticksHomeLayoutMetadata from '@/app/booking-widget/shipsticks.layout.metadata'
import type { HomePageContent } from '@/app/booking-widget/shipsticks.page.content'
import shipsticksHomePageContent from '@/app/booking-widget/shipsticks.page.content'
import shipplayCancellationsAndRefundsLayoutMetadata from '@/app/cancellations-and-refunds/shipplay.layout.metadata'
import shipskisCancellationsAndRefundsLayoutMetadata from '@/app/cancellations-and-refunds/shipskis.layout.metadata'
import shipsticksCancellationsAndRefundsLayoutMetadata from '@/app/cancellations-and-refunds/shipsticks.layout.metadata'
import type { CancellationsAndRefundsPageContent } from '@/app/cancellations-and-refunds/shipsticks.page.content'
import shipsticksCancellationsAndRefundsPageContent from '@/app/cancellations-and-refunds/shipsticks.page.content'
import shipplayCareersLayoutMetadata from '@/app/careers/shipplay.layout.metadata'
import shipplayCareersPageContent from '@/app/careers/shipplay.page.content'
import shipskisCareersLayoutMetadata from '@/app/careers/shipskis.layout.metadata'
import shipskisCareersPageContent from '@/app/careers/shipskis.page.content'
import shipsticksCareersLayoutMetadata from '@/app/careers/shipsticks.layout.metadata'
import type { CareersPageContent } from '@/app/careers/shipsticks.page.content'
import shipsticksCareersPageContent from '@/app/careers/shipsticks.page.content'
import shipplayClaimsPageContent from '@/app/claims/shipplay.page.content'
import shipskisClaimsPageContent from '@/app/claims/shipskis.page.content'
import type { ClaimsPageContent } from '@/app/claims/shipsticks.page.content'
import shipsticksClaimsPageContent from '@/app/claims/shipsticks.page.content'
import shipplayContactLayoutMetadata from '@/app/contact/shipplay.layout.metadata'
import shipplayContactPageContent from '@/app/contact/shipplay.page.content'
import shipskisContactLayoutMetadata from '@/app/contact/shipskis.layout.metadata'
import shipskisContactPageContent from '@/app/contact/shipskis.page.content'
import shipsticksContactLayoutMetadata from '@/app/contact/shipsticks.layout.metadata'
import type { ContactPageContent } from '@/app/contact/shipsticks.page.content'
import shipsticksContactPageContent from '@/app/contact/shipsticks.page.content'
import shipplayFAQLayoutMetadata from '@/app/faq/shipplay.layout.metadata'
import shipplayFAQPageContent from '@/app/faq/shipplay.page.content'
import shipskisFAQLayoutMetadata from '@/app/faq/shipskis.layout.metadata'
import shipskisFAQPageContent from '@/app/faq/shipskis.page.content'
import shipsticksFAQLayoutMetadata from '@/app/faq/shipsticks.layout.metadata'
import type { FAQPageContent } from '@/app/faq/shipsticks.page.content'
import shipsticksFAQPageContent from '@/app/faq/shipsticks.page.content'
import shipplayGiftCardsLayoutMetadata from '@/app/gift-cards/shipplay.layout.metadata'
import shipskisGiftCardsLayoutMetadata from '@/app/gift-cards/shipskis.layout.metadata'
import shipsticksGiftCardsLayoutMetadata from '@/app/gift-cards/shipsticks.layout.metadata'
import shipplayGuaranteeLayoutMetadata from '@/app/guarantee/shipplay.layout.metadata'
import shipplayGuaranteePageContent from '@/app/guarantee/shipplay.page.content'
import shipskisGuaranteeLayoutMetadata from '@/app/guarantee/shipskis.layout.metadata'
import shipskisGuaranteePageContent from '@/app/guarantee/shipskis.page.content'
import shipsticksGuaranteeLayoutMetadata from '@/app/guarantee/shipsticks.layout.metadata'
import type { GuaranteePageContent } from '@/app/guarantee/shipsticks.page.content'
import shipsticksGuaranteePageContent from '@/app/guarantee/shipsticks.page.content'
import shipplayHowItWorksLayoutMetadata from '@/app/how-it-works/shipplay.layout.metadata'
import shipplayHowItWorksPageContent from '@/app/how-it-works/shipplay.page.content'
import shipskisHowItWorksLayoutMetadata from '@/app/how-it-works/shipskis.layout.metadata'
import shipskisHowItWorksPageContent from '@/app/how-it-works/shipskis.page.content'
import shipsticksHowItWorksLayoutMetadata from '@/app/how-it-works/shipsticks.layout.metadata'
import type { HowItWorksPageContent } from '@/app/how-it-works/shipsticks.page.content'
import shipsticksHowItWorksPageContent from '@/app/how-it-works/shipsticks.page.content'
import shipplayPackLayoutMetadata from '@/app/pack/shipplay.layout.metadata'
import shipplayPackPageContent from '@/app/pack/shipplay.page.content'
import shipskisPackLayoutMetadata from '@/app/pack/shipskis.layout.metadata'
import shipskisPackPageContent from '@/app/pack/shipskis.page.content'
import shipsticksPackLayoutMetadata from '@/app/pack/shipsticks.layout.metadata'
import type { PackPageContent } from '@/app/pack/shipsticks.page.content'
import shipsticksPackPageContent from '@/app/pack/shipsticks.page.content'
import shipplayPartnershipBenefitsLayoutMetadata from '@/app/partnership-benefits/shipplay.layout.metadata'
import { default as shipplayPartnershipBenefitsPageContent } from '@/app/partnership-benefits/shipplay.page.content'
import shipskisPartnershipBenefitsLayoutMetadata from '@/app/partnership-benefits/shipskis.layout.metadata'
import { default as shipskisPartnershipBenefitsPageContent } from '@/app/partnership-benefits/shipskis.page.content'
import shipsticksPartnershipBenefitsLayoutMetadata from '@/app/partnership-benefits/shipsticks.layout.metadata'
import type { PartnershipBenefitsPageContent } from '@/app/partnership-benefits/shipsticks.page.content'
import { default as shipsticksPartnershipBenefitsPageContent } from '@/app/partnership-benefits/shipsticks.page.content'
import shipplayReferLayoutMetadata from '@/app/refer/shipplay.layout.metadata'
import shipskisReferLayoutMetadata from '@/app/refer/shipskis.layout.metadata'
import shipsticksReferLayoutMetadata from '@/app/refer/shipsticks.layout.metadata'
import shipplayReviewsLayoutMetadata from '@/app/reviews/shipplay.layout.metadata'
import shipplayReviewsPageContent from '@/app/reviews/shipplay.page.content'
import shipskisReviewsLayoutMetadata from '@/app/reviews/shipskis.layout.metadata'
import shipskisReviewsPageContent from '@/app/reviews/shipskis.page.content'
import shipsticksReviewsLayoutMetadata from '@/app/reviews/shipsticks.layout.metadata'
import type { ReviewsPageContent } from '@/app/reviews/shipsticks.page.content'
import shipsticksReviewsPageContent from '@/app/reviews/shipsticks.page.content'
import shipplayRootLayoutMetadata from '@/app/shipplay.layout.metadata'
import shipskisRootLayoutMetadata from '@/app/shipskis.layout.metadata'
import shipsticksRootLayoutMetadata from '@/app/shipsticks.layout.metadata'
import shipplaySiteMapPageContent from '@/app/sitemap/shipplay.page.content'
import shipskisSiteMapPageContent from '@/app/sitemap/shipskis.page.content'
import type { SiteMapPageContent } from '@/app/sitemap/shipsticks.page.content'
import shipsticksSiteMapPageContent from '@/app/sitemap/shipsticks.page.content'
import shipplayTrackOrdersLayoutMetadata from '@/app/track-orders/shipplay.layout.metadata'
import shipskisTrackOrdersLayoutMetadata from '@/app/track-orders/shipskis.layout.metadata'
import shipsticksTrackOrdersLayoutMetadata from '@/app/track-orders/shipsticks.layout.metadata'
import shipplayWhatCanIShipLayoutMetadata from '@/app/what-can-i-ship/shipplay.layout.metadata'
import shipplayWhatCanIShipPageContent from '@/app/what-can-i-ship/shipplay.page.content'
import shipskisWhatCanIShipLayoutMetadata from '@/app/what-can-i-ship/shipskis.layout.metadata'
import shipskisWhatCanIShipPageContent from '@/app/what-can-i-ship/shipskis.page.content'
import shipsticksWhatCanIShipLayoutMetadata from '@/app/what-can-i-ship/shipsticks.layout.metadata'
import type { WhatCanIShipPageContent } from '@/app/what-can-i-ship/shipsticks.page.content'
import shipsticksWhatCanIShipPageContent from '@/app/what-can-i-ship/shipsticks.page.content'
import shipplayLayoutContent from '@/components/shipplay.layout.content'
import shipskisLayoutContent from '@/components/shipskis.layout.content'
import type { Content as LayoutContent } from '@/components/shipsticks.layout.content'
import shipsticksLayoutContent from '@/components/shipsticks.layout.content'
/* eslint-enable max-len */

const BASE_BRAND = 'shipsticks'
const BRANDS = [BASE_BRAND, 'shipcamps', 'shipplay', 'shipskis'] as const

interface Brand {
  key: Key
  label: string
  layoutContent: LayoutContent
  metadata: Record<Layout, Metadata>
  pageContent: PageContent
  shortName: string
  themeClass: ThemeClass
  url: string
}

export type Key = (typeof BRANDS)[number]

type Layout =
  | 'About'
  | 'Affiliate'
  | 'CancellationsAndRefunds'
  | 'Careers'
  | 'Contact'
  | 'FAQ'
  | 'Guarantee'
  | 'GiftCards'
  | 'Home'
  | 'HowItWorks'
  | 'Pack'
  | 'PartnershipBenefits'
  | 'PartnershipTestimonials'
  | 'Refer'
  | 'Reviews'
  | 'Root'
  | 'TrackOrders'
  | 'WhatCanIShip'

interface PageContent {
  About: AboutPageContent
  Affiliate: AffiliatePageContent
  CancellationsAndRefunds: CancellationsAndRefundsPageContent
  Careers: CareersPageContent
  Claims: ClaimsPageContent
  Contact: ContactPageContent
  FAQ: FAQPageContent
  Guarantee: GuaranteePageContent
  Home: HomePageContent
  HowItWorks: HowItWorksPageContent
  Pack: PackPageContent
  PartnershipBenefits: PartnershipBenefitsPageContent
  Reviews: ReviewsPageContent
  SiteMap: SiteMapPageContent
  WhatCanIShip: WhatCanIShipPageContent
}

type ThemeClass = `theme-${Key}`

export interface StructuredData {
  '@context': string
  '@graph'?: Array<{
    '@type': string
    '@id'?: string
    name?: string
    url?: string
    description?: string
    sameAs?: string[]
    primaryImageOfPage?: {
      '@id': string
    }
    logo?: {
      '@type'?: 'ImageObject'
      '@id'?: string
      url?: string
      caption?: string
    }
    image?:
      | {
          '@id'?: string
          '@type'?: 'ImageObject'
          url?: string
        }
      | string
    address?: {
      '@type': 'PostalAddress'
      streetAddress: string
      addressLocality: string
      addressRegion: string
      postalCode: string
      addressCountry: string
    }
    contactPoint?: {
      '@type': 'ContactPoint'
      telephone: string
      email: string
      contactType: string
      areaServed: string
      availableLanguage: string
    }
    publisher?: {
      '@id': string
    }
    potentialAction?: {
      '@type': 'SearchAction'
      target: string
      'query-input': string
    }
    inLanguage?: string
    isPartOf?: {
      '@id': string
    }
    about?: {
      '@id': string
    }
    aggregateRating?: {
      '@type': 'AggregateRating'
      ratingValue?: string | number
      bestRating?: string | number
      worstRating?: string | number
      ratingCount?: string | number
      reviewCount?: string | number
    }
    brand?: {
      '@id'?: string
      '@type'?: 'Organization'
      name?: string
      url?: string
    }
  }>
}

// Prefer NEXT_PUBLIC_BRAND (used by local dev scripts play:dev / skis:dev / sticks:dev)
// then fall back to NEXT_PUBLIC_BRAND_ID (the name Hydra brand_env overrides use org-wide,
// see hydra.staging.shipsticks.com config brand_env maps). Without this fallback, Hydra
// deploys on branded subdomains silently fell back to BASE_BRAND at build time.
const brandEnv = process.env.NEXT_PUBLIC_BRAND ?? process.env.NEXT_PUBLIC_BRAND_ID
const key: Key = brandEnv && new Set(BRANDS).has(brandEnv as Key) ? (brandEnv as Key) : BASE_BRAND

const shipskisMetadata = {
  About: shipskisAboutLayoutMetadata,
  Affiliate: shipskisAffiliateLayoutMetadata,
  CancellationsAndRefunds: shipskisCancellationsAndRefundsLayoutMetadata,
  Careers: shipskisCareersLayoutMetadata,
  Contact: shipskisContactLayoutMetadata,
  FAQ: shipskisFAQLayoutMetadata,
  Guarantee: shipskisGuaranteeLayoutMetadata,
  GiftCards: shipskisGiftCardsLayoutMetadata,
  Home: shipskisHomeLayoutMetadata,
  HowItWorks: shipskisHowItWorksLayoutMetadata,
  Pack: shipskisPackLayoutMetadata,
  PartnershipBenefits: shipskisPartnershipBenefitsLayoutMetadata,
  PartnershipTestimonials: shipskisPartnershipBenefitsLayoutMetadata,
  Refer: shipskisReferLayoutMetadata,
  Reviews: shipskisReviewsLayoutMetadata,
  Root: shipskisRootLayoutMetadata,
  TrackOrders: shipskisTrackOrdersLayoutMetadata,
  WhatCanIShip: shipskisWhatCanIShipLayoutMetadata,
}

const shipsticksMetadata = {
  About: shipsticksAboutLayoutMetadata,
  Affiliate: shipsticksAffiliateLayoutMetadata,
  CancellationsAndRefunds: shipsticksCancellationsAndRefundsLayoutMetadata,
  Careers: shipsticksCareersLayoutMetadata,
  Contact: shipsticksContactLayoutMetadata,
  FAQ: shipsticksFAQLayoutMetadata,
  Guarantee: shipsticksGuaranteeLayoutMetadata,
  GiftCards: shipsticksGiftCardsLayoutMetadata,
  Home: shipsticksHomeLayoutMetadata,
  HowItWorks: shipsticksHowItWorksLayoutMetadata,
  Pack: shipsticksPackLayoutMetadata,
  PartnershipBenefits: shipsticksPartnershipBenefitsLayoutMetadata,
  PartnershipTestimonials: shipsticksPartnershipBenefitsLayoutMetadata,
  Refer: shipsticksReferLayoutMetadata,
  Reviews: shipsticksReviewsLayoutMetadata,
  Root: shipsticksRootLayoutMetadata,
  TrackOrders: shipsticksTrackOrdersLayoutMetadata,
  WhatCanIShip: shipsticksWhatCanIShipLayoutMetadata,
}

const shipskisPageContent: PageContent = {
  About: shipskisAboutPageContent,
  Affiliate: shipskisAffiliatePageContent,
  CancellationsAndRefunds: shipsticksCancellationsAndRefundsPageContent,
  Careers: shipskisCareersPageContent,
  Claims: shipskisClaimsPageContent,
  Contact: shipskisContactPageContent,
  FAQ: shipskisFAQPageContent,
  Guarantee: shipskisGuaranteePageContent,
  Home: shipskisHomePageContent,
  HowItWorks: shipskisHowItWorksPageContent,
  Pack: shipskisPackPageContent,
  PartnershipBenefits: shipskisPartnershipBenefitsPageContent,
  Reviews: shipskisReviewsPageContent,
  SiteMap: shipskisSiteMapPageContent,
  WhatCanIShip: shipskisWhatCanIShipPageContent,
}

const shipsticksPageContent: PageContent = {
  About: shipsticksAboutPageContent,
  Affiliate: shipsticksAffiliatePageContent,
  CancellationsAndRefunds: shipsticksCancellationsAndRefundsPageContent,
  Careers: shipsticksCareersPageContent,
  Claims: shipsticksClaimsPageContent,
  Contact: shipsticksContactPageContent,
  FAQ: shipsticksFAQPageContent,
  Guarantee: shipsticksGuaranteePageContent,
  Home: shipsticksHomePageContent,
  HowItWorks: shipsticksHowItWorksPageContent,
  Pack: shipsticksPackPageContent,
  PartnershipBenefits: shipsticksPartnershipBenefitsPageContent,
  Reviews: shipsticksReviewsPageContent,
  SiteMap: shipsticksSiteMapPageContent,
  WhatCanIShip: shipsticksWhatCanIShipPageContent,
}

const shipplayMetadata = {
  About: shipplayAboutLayoutMetadata,
  Affiliate: shipplayAffiliateLayoutMetadata,
  CancellationsAndRefunds: shipplayCancellationsAndRefundsLayoutMetadata,
  Careers: shipplayCareersLayoutMetadata,
  Contact: shipplayContactLayoutMetadata,
  FAQ: shipplayFAQLayoutMetadata,
  Guarantee: shipplayGuaranteeLayoutMetadata,
  GiftCards: shipplayGiftCardsLayoutMetadata,
  Home: shipplayHomeLayoutMetadata,
  HowItWorks: shipplayHowItWorksLayoutMetadata,
  Pack: shipplayPackLayoutMetadata,
  PartnershipBenefits: shipplayPartnershipBenefitsLayoutMetadata,
  PartnershipTestimonials: shipplayPartnershipBenefitsLayoutMetadata,
  Refer: shipplayReferLayoutMetadata,
  Reviews: shipplayReviewsLayoutMetadata,
  Root: shipplayRootLayoutMetadata,
  TrackOrders: shipplayTrackOrdersLayoutMetadata,
  WhatCanIShip: shipplayWhatCanIShipLayoutMetadata,
}

const shipplayPageContent: PageContent = {
  About: shipplayAboutPageContent,
  Affiliate: shipplayAffiliatePageContent,
  CancellationsAndRefunds: shipsticksCancellationsAndRefundsPageContent,
  Careers: shipplayCareersPageContent,
  Claims: shipplayClaimsPageContent,
  Contact: shipplayContactPageContent,
  FAQ: shipplayFAQPageContent,
  Guarantee: shipplayGuaranteePageContent,
  Home: shipplayHomePageContent,
  HowItWorks: shipplayHowItWorksPageContent,
  Pack: shipplayPackPageContent,
  PartnershipBenefits: shipplayPartnershipBenefitsPageContent,
  Reviews: shipplayReviewsPageContent,
  SiteMap: shipplaySiteMapPageContent,
  WhatCanIShip: shipplayWhatCanIShipPageContent,
}

const shortName = key.replace('ship', '')

export const brand: Brand = {
  key,
  label: 'Ship' + shortName.charAt(0).toUpperCase() + shortName.slice(1),
  layoutContent: {
    shipsticks: shipsticksLayoutContent,
    shipcamps: shipsticksLayoutContent,
    shipplay: shipplayLayoutContent,
    shipskis: shipskisLayoutContent,
  }[key],
  metadata: {
    shipsticks: shipsticksMetadata,
    shipcamps: shipsticksMetadata,
    shipplay: shipplayMetadata,
    shipskis: shipskisMetadata,
  }[key],
  pageContent: {
    shipsticks: shipsticksPageContent,
    shipcamps: shipsticksPageContent,
    shipplay: shipplayPageContent,
    shipskis: shipskisPageContent,
  }[key],
  shortName,
  themeClass: `theme-${key}`,
  url: new URL(`https://www.${key}.com`).toString(),
}

// The four SMS marketing surfaces (footer modal, SMS-only modal,
// order-confirmation card, My Account combined card) used to each have their own
// build-time NEXT_PUBLIC_SMS_* gate here. They are now driven by a single
// runtime per-brand flag — the brand's `smsMarketingEnabled` (Rails admin ->
// GraphQL getBrand), read via useSmsMarketingEnabled()/isSmsMarketingEnabled()
// in src/hooks/useSmsMarketingEnabled.ts.
